import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import PageHero from './components/PageHero';
import PricingCards from './components/PricingCards';
import EventGallery from './components/EventGallery';
import ConsultationBlock from './components/ConsultationBlock';
import EventCtaSection from './components/EventCtaSection';

const EvenementielleIntro = () => (
  <section className="bg-brand-beige py-16 px-6">
    <div className="max-w-4xl mx-auto text-center">
      <p className="font-serif text-xl lg:text-2xl text-brand-anthracite leading-relaxed italic">
        "Transformez vos événements en expériences inoubliables."
      </p>
      <div className="h-px w-24 bg-brand-gold mx-auto mt-6" />
    </div>
  </section>
);

const EventuellePage = () => (
  <>
    <title>Décoration Événementielle Abidjan | Mariages & Anniversaires | Ev & Co Design</title>
    <meta name="description" content="Décoration événementielle haut de gamme à Abidjan : mariages, anniversaires enfants, événements entreprise. Formules dès 350 000 XOF. Studio Ev & Co Design, Côte d'Ivoire." />
    <meta name="keywords" content="décoration événementielle Abidjan, mariage décoration Côte d'Ivoire, anniversaire enfant Abidjan" />
    <link rel="canonical" href="https://evcodesign-ci.com/decoration-evenementielle" />
    <meta property="og:title" content="Décoration Événementielle Abidjan | Ev & Co Design" />
    <meta property="og:description" content="Transformez vos événements en expériences inoubliables. Mariages, anniversaires, corporate à Abidjan." />
    <main className="font-sans bg-brand-beige min-h-screen">
      <Navbar />
      <PageHero
        title="Décoration Événementielle"
        subtitle="Des créations sur mesure pour vos mariages, anniversaires et événements d'entreprise à Abidjan."
        image="https://storage.readdy-site.link/project_files/1fe20a36-8e39-416c-b295-df4be5629e5e/09e0be93-e1db-401b-a4e2-60e1cefaafd9_IMG_2416.png?v=6f442fc20cec3d72022788964e09068e"
        imageAlt="Décoration événementielle Abidjan"
        breadcrumb="Décoration Événementielle"
      />
      <EvenementielleIntro />
      <PricingCards />
      <EventGallery />
      <ConsultationBlock />
      <EventCtaSection />
      <Footer />
    </main>
  </>
);

export default EventuellePage;
